  document.querySelectorAll('.tab').forEach(tab => {
      tab.addEventListener('click', () => {
          document.querySelectorAll('.tab, .content').forEach(el => el.classList.remove('active'));
          tab.classList.add('active');
          document.getElementById(tab.getAttribute('data-tab')).classList.add('active');
      });
  });
  document.querySelectorAll('input[name="unit"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
          const unit = e.target.value;
          document.querySelectorAll('.unit-switch label').forEach(label => label.classList.remove('active'));
          e.target.parentElement.classList.add('active');
          document.querySelectorAll('td[data-cm]').forEach(cell => {
              cell.textContent = `${cell.getAttribute(`data-${unit}`)}`;
          });
      });
  });
